export default "__VITE_ASSET__Fj8VjEao__"